import {Component, Input, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {eCaseAnimations, ECaseDataTable, ParametersService} from "synto-common";

@Component({
  selector: 'app-document-approval-dialog',
  templateUrl: './document-approval-dialog.component.html',
  styleUrls: ['./document-approval-dialog.component.scss'],
  animations: eCaseAnimations
})
export class DocumentApprovalDialogComponent extends ECaseDataTable implements OnInit {

  @Input() approvers: any[];
  displayedColumns = ['name', 'approvalLevel', 'isApprovalProcessed', 'comments', 'formattedApprovalDate'];
  filterObject = {
    'name': '',
    'comments': '',
    'approvalLevel': '',
    'formattedApprovalDate': ''
  };
  filterObjectForSelectFields = {
    'isApprovalProcessed': '',
  };

  constructor(public dialogRef: MatDialogRef<DocumentApprovalDialogComponent>, translate: TranslateService,
              parameterService: ParametersService) {
    super(translate, parameterService);
    this.dialogRef.disableClose = true;
    this.approvers = this.approvers ? this.approvers : [];
    this.serviceArray = this.approvers;
  }

  ngOnInit(): void {
    this.sortActive = 'approvalLevel';
    this.sortDirection = 'asc';
    this.serviceArray = this.approvers;
    this.originalArray = this.approvers;
    this.setDataSourceAttributes();
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
